import LoginPage from "./LoginPage";
import { useEffect, useState } from "react";
import HomePage from "./HomePage";
import { Box, Center, Text } from "@mantine/core";
import { FilterResetProvider } from "../components/TableSort/FilterGroup/FilterResetContext";

function Layout() {
  const [isUserAuthenticated, setIsUserAuthenticated] = useState(false);
  const [isFetching, setIsFetching] = useState(true);
  const [userDetails, setUserDetails] = useState({
    firstName: "",
    lastName: "",
    mailid: "",
    timeZone: "",
    createdTime: "",
  });

  useEffect(() => {
    window.catalyst.auth
      .isUserAuthenticated()
      .then((result: any) => {
        setUserDetails({
          firstName: result.content.first_name,
          lastName: result.content.last_name,
          mailid: result.content.email_id,
          timeZone: result.content.time_zone,
          createdTime: result.content.created_time,
        });
        setIsUserAuthenticated(true);
      })
      .catch((err: any) => {})
      .finally(() => {
        setIsFetching(false);
      });
    console.log("isfetching: " + isFetching);
    console.log("isuserauth: " + isUserAuthenticated);
  }, []);

  return (
    <Box w="100vw" h="100dvh">
      {isFetching ? (
        <Center h="100%">
          <Text c="white">Loading...</Text>
        </Center>
      ) : isUserAuthenticated ? (
        <HomePage />
      ) : (
        <LoginPage />
      )}
    </Box>
  );
}

export default Layout;
